import { api } from '../api';

export const userVerificationReminderPopupDisable: () => Promise<void> = (): Promise<void> => api.post(
  '/verification/data'
);
